module.exports = __webpack_public_path__ + "media/slider/next-67cca726.png";